import React from 'react';
import { Button } from '@mui/material';
import { Modal } from 'framework/ui/ui-builder';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  title?: string;
  message: string;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
}

const DeleteConfirmationModal = ({
  isOpen,
  isLoading,
  title = 'Delete',
  message,
  onConfirm,
  onCancel,
}: DeleteConfirmationModalProps) => {
  const handleConfirm = async () => {
    await onConfirm();
    if (!isLoading) {
      onCancel();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onToggle={() => {
        if (!isLoading) {
          onCancel();
        }
      }}
      hasCancelButton={false}
      buttons={[
        <Button key="confirm" variant="contained" color="primary" loading={isLoading} onClick={handleConfirm}>
          Submit
        </Button>,
        <Button key="cancel" color="primary" variant="outlined" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>,
      ]}
      className="form-modal"
    >
      {message}
    </Modal>
  );
};

export default DeleteConfirmationModal;
